<template>
  <div>
    <b-input-group>
      <b-form-select :state="parentState" id="parent" :plain="true" v-model="parent_id" :size="size">
          <option value="null" disabled>{{$t('insights.selectObjectiveParent')}}</option>
          <option v-for="option in options" :key="option.id" :value="option.id">{{option.title}}</option>
      </b-form-select>
      <b-input-group-append>
        <b-btn v-b-tooltip.hover :title="$t('insights.linkToParent')" variant="outline-success" @click="linkParent" :disabled="isLoading" :size="size">
          <i v-show="!btnLinkRunning" class="fa fa-link fa-lg"></i>
          <i v-show="btnLinkRunning" class="fa fa-spinner fa-lg fa-spin"></i>
        </b-btn>
        <b-btn v-b-tooltip.hover :title="$t('insights.unlinkToParent')" variant="outline-danger" @click="unlinkParent" :disabled="isLoading" :size="size">
          <i v-show="!btnUnlinkRunning" class="fa fa-unlink fa-lg"></i>
          <i v-show="btnUnlinkRunning" class="fa fa-spinner fa-lg fa-spin"></i>
        </b-btn>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>

<script>
import api from '@/services/api'
import i18n from '@/i18n'
import notification, { success, warning, danger } from '@/lib/notification'

notification.init()

export default {
    name: 'ParentSelect',
    props: ['objectiveId', 'size'],
    data() {
        return {
            options: [],
            parent_id: null,
            isLoading: false,
            btnLinkRunning: false,
            btnUnlinkRunning: false,
            parentState: null,
        }
    },
    methods: {
        notificationLinkToParent() {
            success(i18n.t('insights.objectiveAlignedSuccessfully'))
        },
        notificationUnlinkToParent() {
            warning(i18n.t('insights.objectiveMisaligned'))
        },
        notificationError() {
            danger()
        },
        linkParent() {
            this.btnLinkRunning = true
            this.save()
        },
        unlinkParent() {
            this.parent_id = null
            this.btnUnlinkRunning = true
            this.save()
        },
        save() {
            this.isLoading = true
            this.parentState = null
            api.put(`/objectives/${this.objectiveId}`, {
                id: this.objectiveId,
                parent_id: this.parent_id,
            })
                .then(() => {
                    if (this.parent_id) {
                        this.parentState = true
                        this.notificationLinkToParent()
                    } else {
                        this.parentState = null
                        this.notificationUnlinkToParent()
                    }
                })
                .catch(error => {
                    console.log(error)
                    this.parentState = false
                    this.notificationError()
                })
                .finally(() => {
                    this.isLoading = false
                    this.btnLinkRunning = false
                    this.btnUnlinkRunning = false
                })
        },
    },
    mounted() {
        api.get(
            `/objectives/${this.objectiveId}/possible-objective-parents`
        ).then(resp => {
            this.options = resp.data.map(parent => {
                const { id, title } = parent
                return { id, title }
            })
        })
    },
}
</script>
